<app-alert-message *ngFor="let code of codes; let i=index" (close)="onAlertClose(i)" [code]="code" class="w-100"></app-alert-message>
